"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultController = void 0;
var DefaultController_1 = require("./DefaultController");
Object.defineProperty(exports, "DefaultController", { enumerable: true, get: function () { return DefaultController_1.DefaultController; } });
//# sourceMappingURL=module.js.map